<template>
	<lcsj-dialog v-model="showDetailVisible" title="批量审核申购单" :modal="false" width="90%" @close="closeDialog()" cancel-text="取消" confirm-text="确认审核" :confirm-loading="isSubmitting" @confirm="handleAuditSubmit"> <div class="main_bg">
			<div class="item_info border_Warningcolor">
				<div class="audit_header">
					<span class="header_label">审核结果：</span>
					<el-radio-group v-model="isPass">
						<el-radio :label="true">通过</el-radio>
						<el-radio :label="false">驳回</el-radio>
					</el-radio-group>
					<span class="header_tip">已选 {{ groupList.length }} 张申购单，共 {{ totalDtlCount }} 条明细</span>
				</div>
				<div class="header_tip">
					{{ isPass ? "审核通过时须为每条明细填写大于 0 的售价。" : "审核驳回时须逐张填写驳回原因。" }}提交后整批一次落库，任一张申购单不合法则整批不提交。
				</div>
			</div>
			<div v-for="(group, groupIndex) in groupList" :key="group.keyId" class="item_info border_Green">
				<div class="item_title">
					<div class="title">
						第 {{ groupIndex + 1 }} 张　单号：{{ group.code }}　门店：{{ group.storeName }}　申购人：{{ group.creator }}　状态：{{ group.stateStr }}
					</div>
					<div class="btnDiv">明细 {{ group.dtls.length }} 条</div>
				</div>
				<el-table ref="dtlTable" :cell-class-name="$moneyCellClass" :data="group.dtls" style="width: 100%" border fit :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
					<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
					<el-table-column prop="typeName" label="类型" min-width="130"></el-table-column>
					<el-table-column prop="productName" label="系列" min-width="160"></el-table-column>
					<el-table-column prop="specification" label="商品名称" min-width="170"></el-table-column>
					<el-table-column prop="productBrand" label="商品品牌" min-width="140"></el-table-column>
					<el-table-column prop="quantity" label="数量" width="70"></el-table-column>
					<el-table-column prop="unit" label="单位" width="70"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="costMoney" label="成本(元)" width="90"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="shippingCost" label="运费(元)" width="90"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="price" label="售价(元)" min-width="150">
						<template #default="scope">
							<el-input-number
								v-if="isPass"
								v-model.number="scope.row.price"
								placeholder="请输入售价"
								size="small"
								:min="0"
								:step="0.01"
								:precision="2"
								style="width: 100%"
							></el-input-number>
							<span v-else>{{ scope.row.price }}</span>
						</template>
					</el-table-column>
				</el-table>
				<div v-if="!isPass" class="reason_box">
					<span class="reason_label">驳回原因：</span>
					<el-input v-model="group.reason" placeholder="请输入该申购单的驳回原因" type="textarea" rows="3" maxlength="200" show-word-limit></el-input>
				</div>
			</div>
		</div>
		
	</lcsj-dialog>
</template>

<script>
import costPermission from "@/utils/costPermission.js";
import { GetStoreSubscriptionDetailBatch, AuditStoreSubscriptionBatch } from "@/api/productApi.js";
export default {
	mixins: [costPermission],
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showDetailVisible: false,
			loading: false,
			// 整批统一审核结论；驳回原因按单据逐张填写
			isPass: true,
			groupList: []
		};
	},
	computed: {
		totalDtlCount() {
			return this.groupList.reduce((sum, group) => sum + (group.dtls ? group.dtls.length : 0), 0);
		}
	},
	methods: {
		// 打开批量审核弹窗（入参为申购单主键集合）
		showBatchAudit(keyIds) {
			if (!keyIds || keyIds.length == 0) {
				this.$message({
					type: "warning",
					message: "请勾选要审核的申购单"
				});
				return;
			}
			this.isPass = true;
			this.groupList = [];
			this.showDetailVisible = true;
			this.loading = true;
			GetStoreSubscriptionDetailBatch({
				keyIds: keyIds
			})
				.then((res) => {
					if (res.code == 1) {
						this.groupList = this.buildGroups(res.data || []);
						this.refreshTableLayout();
						if (this.groupList.length == 0) {
							this.showDetailVisible = false;
							this.$message({
								type: "warning",
								message: "未获取到申购单明细，请刷新后重试"
							});
						}
					} else {
						this.showDetailVisible = false;
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.showDetailVisible = false;
					this.$message.error("获取申购单明细失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 按申购单分组组装数据
		buildGroups(list) {
			const groups = [];
			list.forEach((main) => {
				const dtls = [];
				(main.dtls || []).forEach((item, index) => {
					const productInfo = item.productTypeInfo || {};
					dtls.push({
						rowNumber: index + 1,
						keyId: item.keyId,
						typeName: productInfo.typeName,
						productName: productInfo.productName,
						specification: productInfo.specification,
						unit: productInfo.unit,
						productBrand: item.productBrand,
						quantity: item.quantity,
						costMoney: item.costMoney,
						shippingCost: item.shippingCost,
						price: item.price
					});
				});
				groups.push({
					keyId: main.keyId,
					code: main.code,
					storeName: main.storeName,
					creator: main.creator,
					state: main.state,
					stateStr: main.stateStr,
					reason: "",
					dtls: dtls
				});
			});
			return groups;
		},
		// 弹窗内表格渲染时容器宽度可能尚未就绪，数据渲染后重算列宽，确保表格铺满可用宽度
		refreshTableLayout() {
			this.$nextTick(() => {
				const tables = this.$refs.dtlTable;
				const list = Array.isArray(tables) ? tables : tables ? [tables] : [];
				list.forEach((table) => {
					if (table && table.doLayout) {
						table.doLayout();
					}
				});
			});
		},
		// 关闭弹窗
		closeDialog() {
			this.showDetailVisible = false;
			this.groupList = [];
			this.isPass = true;
			this.loading = false;
		},
		// 提交批量审核
		handleAuditSubmit() {
			if (this.groupList.length == 0) {
				this.$message({
					type: "warning",
					message: "请先勾选要审核的申购单"
				});
				return;
			}

			const invalidGroup = this.groupList.find((group) => group.state != 3);
			if (invalidGroup) {
				this.$message({
					type: "warning",
					message: `申购单【${invalidGroup.code}】不是【待审核】状态，不能审核`
				});
				return;
			}

			if (!this.isPass) {
				const noReasonGroup = this.groupList.find((group) => !group.reason || !group.reason.trim());
				if (noReasonGroup) {
					this.$message({
						type: "warning",
						message: `请填写申购单【${noReasonGroup.code}】的驳回原因`
					});
					return;
				}
			} else {
				let invalidGroupInfo = null;
				let invalidDtlInfo = null;
				for (let i = 0; i < this.groupList.length; i++) {
					const group = this.groupList[i];
					if (!group.dtls || group.dtls.length == 0) {
						invalidGroupInfo = group;
						break;
					}
					const dtl = group.dtls.find((item) => !(Number(item.price) > 0));
					if (dtl) {
						invalidGroupInfo = group;
						invalidDtlInfo = dtl;
						break;
					}
				}
				if (invalidGroupInfo) {
					this.$message({
						type: "warning",
						message: invalidDtlInfo
							? `申购单【${invalidGroupInfo.code}】的【${invalidDtlInfo.specification}】售价必须大于 0`
							: `申购单【${invalidGroupInfo.code}】没有商品明细，不能审核通过`
					});
					return;
				}
			}

			this.$confirm(`确认${this.isPass ? "通过" : "驳回"}选中的 ${this.groupList.length} 张申购单吗？`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				const params = {
					items: this.groupList.map((group) => ({
						keyId: group.keyId,
						isPass: this.isPass,
						reason: this.isPass ? "" : group.reason,
						dtls: this.isPass
							? group.dtls.map((dtl) => ({
									keyId: dtl.keyId,
									price: dtl.price
							  }))
							: null
					}))
				};
				AuditStoreSubscriptionBatch(params)
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: res.msg || "审核成功"
							});
							this.closeDialog();
							this.$parent.getListData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.finally(() => {
						this.loading = false;
					});
			});
		}
	}
};
</script>
<style scoped>
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border: 2px solid var(--app-border);
}

.border_Warningcolor {
	border-left: 5px solid var(--app-warning);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;
}

.item_title .title {
	display: inline-block;
	unicode-bidi: isolate;
}

.item_title .btnDiv {
	display: block;
	unicode-bidi: isolate;
	word-break: break-all;
}

.audit_header {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.audit_header .header_label {
	font-weight: 700;
	margin-right: 10px;
}

.audit_header .header_tip {
	margin-left: 20px;
	color: var(--app-text-muted);
}

.header_tip {
	color: var(--app-text-muted);
	line-height: 1.6;
}

.reason_box {
	margin-top: 10px;
}

.reason_box .reason_label {
	display: block;
	font-weight: 700;
	margin-bottom: 8px;
}
</style>
